export default __webpack_public_path__ + "static/media/icon-login.80f87a0e.svg";